import { Box, Icon, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { primitive } from 'styles/constants/primitives';

type CashappErrorProps = {
  type?: 'declined' | 'failed';
};
export function CashappError({ type = 'declined' }: CashappErrorProps) {
  const { formatMessage } = useIntl();

  const message =
    type === 'declined'
      ? formatMessage({ id: 'cashAppDecline' })
      : formatMessage({ id: 'cashAppError' });

  useLogUserErrorMessage({
    message: 'CashAppButton: ' + message,
    severity: LogUserErrorSeverity.Recoverable,
  });

  return (
    <ErrorContainer>
      <Icon variant="warning" size={'4'} marginRight={2} />
      <ErrorText>{message}</ErrorText>
    </ErrorContainer>
  );
}

export const ErrorContainer = Box.withConfig({
  backgroundColor: primitive.bk.$errorLight,
  marginBottom: '$6',
  paddingX: '$6',
  paddingY: '$2',
  paddingRight: '$6',
  flexDirection: 'row',
  alignItems: 'center',
});

export const ErrorText = Text.withConfig({
  color: primitive.bk.$bbqBrown,
  fontSize: 'sm',
});
